module.exports = __webpack_public_path__ + "img/logo-v.824b2e1f.png";